import './CardViewComponent.css';
import Tooltip from '../Tooltip/Tooltip';

import {
  Card,
  Box,
  Typography,
  CardContent,
  FormControl,
} from '@deere/fuel-react';
import React from 'react';

const CardViewComponent = (props) => {
  return (
    <Box pl={4} pr={4} pb={4} className={'dashboardCardCustomSection'}>
      <Card className="dashboardCardCustom">
        <CardContent className="CardContentCustom">
          {props.records &&
            Object.keys(props.records).map((key, index) => {
              return (
                <FormControl
                  fullWidth
                  key={'card-view' + key}
                  id={`CardViewRow` + key}
                  className="CardContentBlock"
                >
                  <Typography variant="label" className={'label'}>
                    {props.records[key].label}
                    {props.records[key].tooltip && (
                      <Tooltip tooltip={props.records[key].tooltip} />
                    )}
                  </Typography>
                  <Typography className={`value`}>
                    {props.records[key].value}
                  </Typography>
                </FormControl>
              );
            })}
        </CardContent>
      </Card>
    </Box>
  );
};
export default CardViewComponent;
